import cn from "classnames";
import * as React from "react";

import styles from "./DisclosureTriangle.module.scss";

type Direction = "down" | "up";

const triangle = "▾";

interface Props {
  className?: string;
  direction: Direction;
}

const ROTATIONS: Record<Direction, number> = {
  down: 0,
  up: 180,
};

const DisclosureTriangle = ({ className, direction }: Props) => (
  <div
    className={cn(styles.wrap, className)}
    style={{
      transform: `rotate(${ROTATIONS[direction]}deg)`,
    }}
  >
    {triangle}
  </div>
);

export default DisclosureTriangle;
